import React, {useState, useEffect} from "react"

import Data from "./../data"

// context
const CatalogueContext = React.createContext()

// the provider
const CatalogueProvider = (props) => {
  // household data 
  const [activities, setActivities] = useState(null)
  const [activityPackages, setActivityPackages] = useState([]);
  const [regions, setRegions] = useState([]);

  // flag when ready
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    // load the catalogue, regions, shipping types, and properties
    Data.load().then(({catalogue, activityPackages, regions}) => {
      // consumers of the CatalogueContext (so far) only access the catalogue and activityPackages, if regions, properties, shippingTypes should ever be needed simply destructer those as well, like so: {catalogue, regions, properties, shippingTypes}
      setActivities(catalogue);
      setActivityPackages(activityPackages);
      setRegions(regions);

      // we are ready
      setIsReady(true);
    })

  }, []) // setting reference array to [] -> callback only fired once
  
  // the value provided
  let providerValue = {
    activities,
    activityPackages,
    regions,
    isReady
  }

  return (
    <CatalogueContext.Provider value={providerValue}>
      {props.children}
    </CatalogueContext.Provider>
  )
}

export {CatalogueContext, CatalogueProvider}


// TODO since we alredy have all the data in the context provider's state, is it really necessary to also store tin the data/catalogue, data/region, data/properties containers? ... all the data points at the same reference (I think), but still ...